const CatalogItemsConstants = {
    SET_PRODUCTS_ACTION: 'SET_PRODUCTS_ACTION',
    LOAD_CATALOG_ITEMS_ACTION: 'LOAD_CATALOG_ITEMS_ACTION',
    SET_BUYER_ASSIST_URL: 'SET_BUYER_ASSIST_URL',
};

export default CatalogItemsConstants;